var map = {
	"./IMAGE.png": 61919,
	"./PDF.png": 59390,
	"./PPT.png": 76448,
	"./RAR.png": 98179,
	"./TXT.png": 19308,
	"./Word.png": 77770,
	"./Zip.png": 63137,
	"./answer.png": 27864,
	"./close.png": 31228,
	"./detailBg.png": 81816,
	"./exam.png": 42887,
	"./finishwork.png": 15340,
	"./ico_add@2x.png": 8837,
	"./left-disable.png": 19646,
	"./left.png": 41689,
	"./mockExam.png": 20249,
	"./mp3.png": 51826,
	"./mp4.png": 56685,
	"./other.png": 68394,
	"./right-disable.png": 67941,
	"./right.png": 58146,
	"./rightAnswers.png": 51221,
	"./scoreImg.png": 95037,
	"./scoreImg1.png": 27168,
	"./setting.png": 83116,
	"./shortQuestion.png": 24114,
	"./shortQuestionBottom.png": 19519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44773;